export const proxy = "https://back.freebrokers.online";